import FormFooter from 'components/organisms/Form/FormFooter/FormFooter'
import { Form, Formik } from 'formik'
import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'
import { FaEdit, FaTrashAlt } from 'react-icons/fa'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import * as Yup from 'yup'
import * as FormConst from '../../../../constants/FormConst'
import RouteConst from '../../../../constants/RouteConst'
import SessionConst from '../../../../constants/SessionConst'
import SideNavEntryMapping from '../../../../constants/SideNavEntryMapping'
import { asyncMethod } from '../../../../redux/actions'
import * as actionTypes from '../../../../redux/actionTypes'
import DestinationsService from '../../../../services/DestinationsService'
import {isArrayNotEmpty, isCompletedHotelInfoHistory, isObjectEmpty, scrollToHtmlElementById} from '../../../../utilities/JSUtil'
import { getSessionItem } from '../../../../utilities/SessionHelper'
import Button from '../../../atoms/Button/Button'
import SelectInput from '../../../atoms/form/SelectInput/SelectInput'
import TextInput from '../../../atoms/form/TextInput/TextInput'
import ToggleSwitch from '../../../atoms/form/ToggleSwitch/ToggleSwitch'
import FormModal from '../../../organisms/FormModal/FormModal'
import withFormLayout from '../WithFormLayout'
import './Lounges.scss'


class Lounges extends Component {

    constructor(props) {
        super(props)
        const hotelCode = getSessionItem(SessionConst.HOTEL_CODE)
        const hotelInfo = getSessionItem(SessionConst.HOTEL_INFO)
        const hotelInfoCompletedHistory = getSessionItem(SessionConst.HOTEL_INFO_COMPLETED_HISTORY)

        if (!hotelCode || !hotelInfo) {
            this.props.history.replace(RouteConst.ROUTE_HOME_PAGE)
        }

        this.state = {
            hotelCode: hotelCode,
            hotelInfo: hotelInfo,
            continueFlow: this.props.history.location?.state?.continueFlow,
            distanceUnits: getSessionItem(SessionConst.DISTANCE_UNIT_LABEL),
            lounges: [],
            otherDestinationEntries: {},
            isEdit: false,
            editIndex: -1,
            showNewLoungesFields: false,
            deleteIndex: -1,
            showDeleteModal: false,
            initialValues: { ...this.initialValues },
            isLoading: true,
            loadingMessage: FormConst.MODAL_READ_ACTION_TEXT,
            hotelInfoCompletedHistory: hotelInfoCompletedHistory
        }
    }

    /**
     * Lifecycle method that runs after the component mounts.
     * Gets data from the session if state is COMPLETED, otherwise from the service, and sets initial values for the form.
     */
    async componentDidMount() {
        if (isCompletedHotelInfoHistory(this.state.hotelInfoCompletedHistory)) {
            let hotelDestinations = this.state.hotelInfoCompletedHistory.newEntity?.hotelDestinations?.hotelDestinations;

            if (hotelDestinations) {
                await this.buildFormValues(hotelDestinations);
            } else {
                this.setState({ error: 'Could not retrieve details', isLoading: false })
            }
        } else {
            await DestinationsService.getHotelDestinations({ hotelCode: this.state.hotelCode })
                .then(async response => {
                    let hotelDestinations = response?.hotelDestinations;
                    if (hotelDestinations) {
                        await this.buildFormValues(hotelDestinations);
                    }
                }).catch(error => {
                    this.setState({ error: 'Could not retrieve details', isLoading: false })
                });
        }
    }

    async buildFormValues(hotelDestinations) {
        let existingLounges = []
        let otherDestinationEntries = {}

        const lounges = hotelDestinations.lounge;
        otherDestinationEntries = !isObjectEmpty(hotelDestinations) ? {
                ...hotelDestinations,
                lounge: undefined
            }
            :
            { lounge: undefined }
        if (lounges) {
            existingLounges = lounges && lounges.length > 0 ? [...lounges] : []
        }

        this.setState({
            lounges: existingLounges,
            otherDestinationEntries: otherDestinationEntries,
            isLoading: false
        })
    }

    initialValues = {
        name: '',
        location: '',
        isDancing: false,
        isEntertainment: false,
        isFood: false,
        distance: 0,
        direction: '',
        openingTime: '',
        closingTime: ''
    }

    validationSchema = Yup.object().shape({
        loungeName: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
            .max(FormConst.DESTINATION_NAME_MAX_LENGTH, `Up to ${FormConst.DESTINATION_NAME_MAX_LENGTH} characters allowed`)
            .matches(FormConst.TEXT_PATTERN, FormConst.VALIDATION_ERROR_SPECIAL_CHARACTERS),
        location: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
        isDancing: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
        isEntertainment: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
        isFood: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
        distance: Yup.number().when("location", {
            is: FormConst.VALUE_NEARBY,
            then: Yup.number().required(FormConst.VALIDATION_ERROR_REQUIRED)
                .min(0, FormConst.VALIDATION_ERROR_NUMBER_GREATER_THAN_OR_EQUAL_TO_ZERO)
                .max(FormConst.MAX_DESTINATION_DISTANCE, FormConst.VALIDATION_ERROR_DESTINATIONS_DISTANCE)
        }),
        direction: Yup.string().when("location", {
            is: FormConst.VALUE_NEARBY,
            then: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
        }),
        openingTime: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
        closingTime: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
    })

    handleSubmit = (formData) => {
        let lounges = this.state.lounges.length > 0 ? [...this.state.lounges] : []
        const newEntry = {
            destinationType: FormConst.DESTINATION_TYPE_LOUNGE,
            name: formData.loungeName.trim(),
            proximity: {
                location: formData.location,
                distanceValue: formData.location === FormConst.VALUE_NEARBY ? formData.distance : 0,
                distanceUnit: this.state.distanceUnits,
                direction: formData.location === FormConst.VALUE_NEARBY ? formData.direction : undefined
            },
            dancingAvailable: formData.isDancing,
            entertainmentAvailable: formData.isEntertainment,
            foodAvailable: formData.isFood,
            operatingHours: formData.openingTime && formData.closingTime
                ? {
                    open: formData.openingTime,
                    close: formData.closingTime
                }
                : undefined
        }
        if (this.state.isEdit) {
            // Edit existing entry
            lounges[this.state.editIndex] = newEntry
        } else {
            lounges.push(newEntry)
        }

        let newDestinationEntries
        if (this.state.otherDestinationEntries) {
            newDestinationEntries = {
                ...this.state.otherDestinationEntries,
                lounge: [...lounges]
            }
        } else {
            newDestinationEntries = {
                lounge: [...lounges]
            }
        }

        this.props.onPut({ hotelCode: this.state.hotelCode, formData: newDestinationEntries })

        this.setState({
            pendingLounges: [...lounges],
            newPendingLounge: { ...formData },
            isLoading: true,
            loadingMessage: FormConst.MODAL_UPDATE_ACTION_TEXT
        })
    }

    handleReset = () => {
    }

    handleDelete = (index) => {
        this.setState({ showDeleteModal: true, deleteIndex: index })
    }

    handleClearForm = () => {
        this.setState({ showResetModal: true })
    }

    discardNewFields = (formikResetForm) => {
        formikResetForm({ ...this.initialValues })
        // Scroll the table into view after discarding
        scrollToHtmlElementById('lounges-table')
        this.setState({
            initialValues: { ...this.initialValues },
            isEdit: false,
            editIndex: -1,
            showNewLoungesFields: false,
            showResetModal: false
        })
    }

    handleProceed = () => {
        // Continue to next form
        if (this.state.continueFlow) {
            // Go to the next page
            this.props.history.push({
                pathname: RouteConst.ROUTE_ATTRACTIONS_PAGE,
                state: {
                    continueFlow: this.state.continueFlow
                }
            })
        } else {
            // Go back to Destinations page
            this.props.history.push(RouteConst.ROUTE_DESTINATIONS_PAGE)
        }
    }

    onEdit = (index) => {
        const entryToEdit = this.state.lounges[index]
        this.setState({
            isEdit: true,
            editIndex: index,
            initialValues: {
                loungeName: entryToEdit.name,
                location: entryToEdit.proximity.location,
                isDancing: entryToEdit.dancingAvailable || false,
                isEntertainment: entryToEdit.entertainmentAvailable || false,
                isFood: entryToEdit.foodAvailable || false,
                distance: entryToEdit.proximity.distanceValue,
                direction: entryToEdit.proximity.direction,
                openingTime: entryToEdit.operatingHours.open,
                closingTime: entryToEdit.operatingHours.close
            },
            showNewLoungesFields: true
        })

    }

    onDelete = () => {
        let index = this.state.deleteIndex
        let lounges = [...this.state.lounges]
        lounges.splice(index, 1)

        let newDestinationEntries

        if (lounges.length > 0 && !isObjectEmpty(this.state.otherDestinationEntries)) {
            newDestinationEntries = {
                ...this.state.otherDestinationEntries,
                lounge: [...lounges]
            }
        } else if (lounges.length > 0) {
            newDestinationEntries = {
                lounge: [...lounges]
            }
        } else {
            newDestinationEntries = {
                ...this.state.otherDestinationEntries
            }
        }

        this.props.onPut({ hotelCode: this.state.hotelCode, formData: newDestinationEntries })

        this.setState({
            pendingLounges: [...lounges],
            newPendingLounge: undefined,
            isLoading: true,
            loadingMessage: FormConst.MODAL_UPDATE_ACTION_TEXT,
            showDeleteModal: false
        })
    }

    showNewLoungesFields = () => {
        this.setState({
            isEdit: false, editIndex: -1, showNewLoungesFields: true, loungeCodeOptions: []
        })
    }

    componentDidUpdate(prevProps) {
        if (prevProps.count !== this.props.count) {
            if (this.props.errorMessage) {
                this.setState({
                    isLoading: false,
                    showErrorModal: true,
                    errorMessage: this.props.errorDescription,
                    pendingLounges: undefined,
                    newPendingLounge: undefined,
                    initialValues: {
                        ...this.initialValues,
                        ...this.state.newPendingLounge
                    }
                })
            } else {
                // Scroll the table into view after saving
                scrollToHtmlElementById('lounges-table')
                this.setState({
                    isLoading: false, lounges: this.state.pendingLounges,
                    initialValues: { ...this.initialValues }, showNewLoungesFields: false,
                    isEdit: false, editIndex: -1, deleteIndex: -1, showDeleteModal: false
                })
            }
        }
    }

    render() {
        let formTable = <table id='lounges-table' className='table table-striped lounges-table'>
            <thead>
                <tr>
                    <th>Lounge Name</th>
                    <th className='d-none d-xl-table-cell'>Location</th>
                    <th className='d-none d-xl-table-cell'>Dancing</th>
                    <th className='d-none d-xl-table-cell'>Entertainment</th>
                    <th className='d-none d-xl-table-cell'>Food</th>
                    <th>Edit</th>
                    <th>Delete</th>
                </tr>
            </thead>
            <tbody>
                {
                    isArrayNotEmpty(this.state.lounges)
                        ? this.state.lounges.map((lounge, index) => {
                            return <tr key={index}>
                                <td>{lounge.name}</td>
                                <td className='d-none d-xl-table-cell'>{lounge.proximity.location}</td>
                                <td className='d-none d-xl-table-cell'>{lounge.dancingAvailable ? FormConst.VALUE_YES : FormConst.VALUE_NO}</td>
                                <td className='d-none d-xl-table-cell'>{lounge.entertainmentAvailable ? FormConst.VALUE_YES : FormConst.VALUE_NO}</td>
                                <td className='d-none d-xl-table-cell'>{lounge.foodAvailable ? FormConst.VALUE_YES : FormConst.VALUE_NO}</td>
                                <td><Button name={<FaEdit />} role='link' className={this.state.showNewLoungesFields ? 'icon-link-disabled' : 'icon-link'} onClick={() => this.onEdit(index)} overridedisabledflag='true' /></td>
                                <td><Button name={<FaTrashAlt />} role='link' className={this.state.showNewLoungesFields ? 'icon-link-disabled' : 'icon-link'} onClick={() => this.handleDelete(index)} /></td>
                            </tr>
                        })
                        : <tr>
                            <td colSpan={7}>There are no entries for lounges</td>
                        </tr>
                }
            </tbody>
        </table>

        return (
            <Formik
                initialValues={this.state.initialValues}
                validationSchema={this.validationSchema}
                enableReinitialize={true}
                onSubmit={(data, { setSubmitting, resetForm }) => {
                    setSubmitting(true)
                    this.handleSubmit(data)
                    setSubmitting(false)
                    resetForm()
                }}>
                {
                    ({ values, errors, touched, dirty, isSubmitting, isValid, resetForm, handleChange }) => (
                        <Form className='lounges-form'>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><NavLink to={RouteConst.ROUTE_HOME_PAGE}>Home</NavLink></li>
                                    <li className="breadcrumb-item"><NavLink to={RouteConst.ROUTE_DESTINATIONS_PAGE}>Destinations</NavLink></li>
                                    <li className="breadcrumb-item active" aria-current="page">Lounges</li>
                                </ol>
                            </nav>
                            <p className='hotel-destinations-type'>Lounges</p>
                            <p className='helper-text'>{FormConst.LOUNGES_HELPER_TEXT}</p>

                            {formTable}

                            {
                                this.state.lounges.length < FormConst.DESTINATIONS_CATEGORY_LOCAL_ATTRACTIONS_MAX_COUNT
                                && <div className='new-lounges-fields-toggle'>
                                    <Button
                                        id='add-lounge-button'
                                        name='Add Lounge'
                                        disabled={this.state.showNewLoungesFields}
                                        onClick={this.showNewLoungesFields} />
                                </div>
                            }

                            {/* Show new lounge fields only when add button is clicked */}
                            {
                                this.state.showNewLoungesFields
                                && <div id='new-lounge-collapse-fields'>
                                    <div className='new-lounge-form-fields'>
                                        <TextInput name='loungeName' type='text'
                                            label='Lounge Name' isrequired='true' />
                                        <SelectInput name='location' type='text'
                                            label='Location' isrequired='true' options={FormConst.LOCATION_OPTIONS} />
                                        <ToggleSwitch
                                            id='is-dancing'
                                            name='isDancing'
                                            checked={values.isDancing}
                                            label='Dancing?'
                                            options={FormConst.SWITCH_OPTIONS_YES_NO}
                                            onChange={handleChange} />
                                        <ToggleSwitch
                                            id='is-entertainment'
                                            name='isEntertainment'
                                            checked={values.isEntertainment}
                                            label='Entertainment?'
                                            options={FormConst.SWITCH_OPTIONS_YES_NO}
                                            onChange={handleChange} />
                                        <ToggleSwitch
                                            id='is-food'
                                            name='isFood'
                                            checked={values.isFood}
                                            label='Food?'
                                            options={FormConst.SWITCH_OPTIONS_YES_NO}
                                            onChange={handleChange} />
                                        <TextInput name='distance' type='number'
                                            label='Distance' isdependent='true' suffix={this.state.distanceUnits}
                                            disabled={values.location === FormConst.VALUE_ONSITE || values.location === FormConst.VALUE_ADJACENT}
                                            min={0} max={FormConst.MAX_DESTINATION_DISTANCE} step='0.5' />
                                        <SelectInput name='direction' label='Direction'
                                            isdependent='true' options={FormConst.DIRECTION_OPTIONS}
                                            disabled={values.location === FormConst.VALUE_ONSITE || values.location === FormConst.VALUE_ADJACENT} />
                                        <TextInput name='openingTime' type='time' label='Opening Time' isrequired='true' />
                                        <TextInput name='closingTime' type='time' label='Closing Time' isrequired='true' />
                                    </div>
                                    <Row>
                                        <Col xs={3} sm={2} lg={1}><Button role='link' type="submit" name={FormConst.SAVE_LINK_TEXT} className="new-lounge-action-button" formNoValidate /></Col>
                                        <Col xs={4} sm={2} lg={1}><Button role='link' name={FormConst.DISCARD_LINK_TEXT} className="new-lounge-action-button" onClick={() => {
                                            if (dirty) {
                                                this.handleClearForm()
                                            } else {
                                                this.discardNewFields(resetForm)
                                            }
                                        }
                                        }
                                            overridedisabledflag='true' /></Col>
                                    </Row>
                                </div>
                            }

                            {
                                this.state.showNewLoungesFields
                                && <p className='error text-center'>Please save or discard your changes to proceed</p>
                            }

                            <FormFooter
                                form={{
                                    previous: { title: 'Restaurants', route: RouteConst.ROUTE_RESTAURANTS_PAGE },
                                    next: { title: 'Attractions', route: RouteConst.ROUTE_ATTRACTIONS_PAGE }
                                }}
                                submitName={this.state.continueFlow ? 'Proceed to Attractions' : 'Go back to Destinations'}
                                onSubmit={this.handleProceed}
                                submitDisabled={this.state.showNewLoungesFields}
                                noReset />
                            <FormModal
                                id='lounges-page-save-modal'
                                title={FormConst.MODAL_UPDATE_ACTION_TITLE}
                                hotelInfo={this.state.hotelInfo}
                                body={<h5>{this.state.loadingMessage}</h5>}
                                show={this.state.isLoading}
                                isLoadingIndicator />
                            <FormModal
                                id='lounges-page-discard-modal'
                                hotelInfo={this.state.hotelInfo}
                                title={FormConst.MODAL_DISCARD_ACTION_TITLE}
                                body={<h5>{FormConst.MODAL_DISCARD_ACTION_TEXT}</h5>}
                                proceed={() => {
                                    this.discardNewFields(resetForm)
                                }}
                                cancel={() => { this.setState({ showResetModal: false }) }}
                                show={this.state.showResetModal} />
                            <FormModal
                                id='lounges-page-delete-modal'
                                hotelInfo={this.state.hotelInfo}
                                title={'Delete Lounge'}
                                body={<h5>{FormConst.MODAL_DELETE_ACTION_TEXT}</h5>}
                                proceed={this.onDelete}
                                cancel={() => { this.setState({ showDeleteModal: false }) }}
                                show={this.state.showDeleteModal} />
                            <FormModal
                                id='lounges-page-error-modal'
                                hotelInfo={this.state.hotelInfo}
                                title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                                body={<h5>{this.state.errorMessage}</h5>}
                                isError
                                cancel={() => { this.setState({ showErrorModal: false }) }}
                                show={this.state.showErrorModal} />
                        </Form>
                    )
                }
            </Formik>
        )
    }
}

// Sample redux dispatch
const mapStateToProps = state => {
    return {
        destinationsResponse: state.reducer.response,
        errorMessage: state.reducer.errorMessage,
        errorDescription: state.reducer.errorDescription,
        count: state.reducer.count
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onGet: (hotelCode) => dispatch(asyncMethod(FormConst.FORM_HOTEL_DESTINATIONS_NAME, actionTypes.ASYNC_ACTIONS.GET, { hotelCode: hotelCode })),
        onPut: (data) => dispatch(asyncMethod(FormConst.FORM_HOTEL_DESTINATIONS_NAME, actionTypes.ASYNC_ACTIONS.PUT, data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withFormLayout(Lounges, SideNavEntryMapping.HOTEL_DESTINATIONS))